import React, { FC, MutableRefObject, ReactNode } from 'react';
import classNames from 'classnames';

import getClassName from 'src/common/utils/getClassName';
import Icon from 'src/common/components/IconDS22';
import s from './NotificationMessage.module.scss';

export type NotificationMessageProps = {
  children: ReactNode;
  withIcon?: boolean;
  outdent?: boolean;
  classNameModifier?: string;
  rootRef?: MutableRefObject<null | HTMLDivElement>;
  variant?: 'warning' | 'info' | 'error';
};

const NotificationMessage: FC<NotificationMessageProps> = ({
  children,
  classNameModifier,
  outdent = true,
  withIcon = true,
  rootRef,
  variant = 'warning',
}) => {
  const modifiers = classNames(classNameModifier, variant, { outdent, withIcon });

  return (
    <div
      className={getClassName(s, 'root', modifiers)}
      ref={rootRef}
    >
      {withIcon && (
        <Icon
          id={variant === 'warning' ? 'warning' : 'info'}
          className={getClassName(s, 'icon', modifiers)}
        />
      )}
      {children && (
        <div data-test="warningMessage">
          {children}
        </div>
      )}
    </div>
  );
};

export default NotificationMessage;
